import { Component, OnInit } from '@angular/core';
import {DialogRef} from "@fundamental-ngx/core/dialog";

@Component({
    selector: 'app-constraints-dialog',
    templateUrl: './constraints-dialog.component.html',
    styleUrls: ['./constraints-dialog.component.scss'],
    standalone: false
})
export class ConstraintsDialogComponent implements OnInit {

    constructor(public dialogRef: DialogRef) { }
    constraintSets: any[] = [];
    setCount = 1;
    JSON = JSON;
    data: any;
    source: string;

    ngOnInit(): void {
        this.data = this.dialogRef.data.data;
        this.source = this.dialogRef.data.source;
        this.addConstraints(this.data.constraints?.allow?.identity, "At least one");
        this.addConstraints(this.data.constraints?.allow?.hierarchy, "At least one");
        this.addConstraints(this.data.constraints?.deny, "All");
    }

    addConstraints(constraints: any, rulePrefixText: string) {
        if(!constraints) {
            return;
        }
        const constraintString = constraints.length > 1 ? 'constraints' : 'constraint';
        this.constraintSets.push({
            title: `Set ${this.setCount} (${constraints.length} ${constraintString})`,
            rulePrefixText: rulePrefixText,
            constraints: constraints.map((c: any) => {
                return {
                    type: c.policyMetadata.type,
                    description: c.policyMetadata.description,
                    parameters: c.parameters
                };
            })

        });
        this.setCount++;
    }

}
